import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import CardPillLabel from "../../../components/ui/CardPillLabel";
import { timelineItems } from "../data/timelineItems";
import {
  IconAnchor,
  IconHelm,
  IconShieldCross,
  IconPillar,
  IconCrown,
  IconCross,
  IconStarSaint,
  IconFlame,
} from "../../../components/ui/Icons";

const MotionLink = motion(Link);

const CARD_BTN = {
  "okno-na-swiat":          { label: "1918 · Wolność",       Icon: IconAnchor      },
  "leonid-teliga":          { label: "1967 · Marzenie",      Icon: IconHelm        },
  "sobek":                  { label: "XIII w. · Rycerze",    Icon: IconShieldCross },
  "grod-kerin":             { label: "V w. p.n.e. · Grecja", Icon: IconPillar      },
  "rzym":                   { label: "I w. · Rzym",          Icon: IconCrown       },
  "slowianie-i-wikingowie": { label: "966 · Chrzest",        Icon: IconCross       },
  "sw-wojciech":            { label: "997 · Święty",         Icon: IconStarSaint   },
  "odwaga":                 { label: "Odwaga",               Icon: IconFlame       },
};

export default function TimelineLandingPage() {
  return (
    <section className="pageSection pageWithHeaderOffset">
      <div className="container">
        <div className="card cardLabeled">
          <CardPillLabel text="Ścieżka czasu" variant="miejsca" />
          <h1 className="h1">Ścieżka czasu</h1>
          <p className="pageLead">Ścieżka czasu prowadzi przez kolejne epoki, wydarzenia i opowieści, które kształtowały świat, Europę i nas samych. Każdy punkt to osobna historia , do której możesz wejść głębiej i odkryć jej znaczenie.</p>
          <div className="timelineGrid">
            {timelineItems.map((item, index) => (
              <MotionLink
                key={item.slug}
                to={`/sciezka-czasu/${item.slug}`}
                className="timelineCard"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 1.4, ease: "easeOut", delay: index * 0.12 }}
              >
                <img src={item.image} alt={item.title} className="timelineCardImg" />
                <div className="timelineCardBody">
                  <div className="timelineCardTitle">{item.title}</div>
                  <div className="timelineCardSubtitle">{item.subtitle}</div>
                  <p className="timelineCardText">{item.description}</p>
                  {CARD_BTN[item.slug] && (() => {
                    const { label, Icon } = CARD_BTN[item.slug];
                    return (
                      <motion.div
                        className="timelineCardBtn"
                        initial={{ opacity: 0, y: 24 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, amount: 0.25 }}
                        transition={{ duration: 1.6, ease: "easeOut" }}
                      >
                        <span className="timelineCardBtnLabel">{label}</span>
                        <span className="timelineCardBtnIcon"><Icon /></span>
                      </motion.div>
                    );
                  })()}
                </div>
              </MotionLink>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}